import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Tacoma from '../../components/Tacoma/Tacoma'

const Tacomapage = () => {
    return (
        <div>
        <Navbar/>
        <Tacoma/>


        <Footer/>

        </div>
    )
}

export default Tacomapage